const conf = {
  // Your web app's Firebase configuration
  firebaseConfig: {
    apiKey: 'AIzaSyCsH3gpVFsYPiImzdLmrTRTaBnrqq8teDk',
    authDomain: 'tpfla-v3.firebaseapp.com',
    databaseURL: 'https://tpfla-v3.firebaseio.com',
    projectId: 'tpfla-v3',
    storageBucket: 'tpfla-v3.appspot.com',
    messagingSenderId: '272443276118',
    appId: '1:272443276118:web:e6198d0838fbf81d6374f7'
  },
  // Password for new users
  predefinedPassword: 'hello',
  locations: {
    0: { id: 0, title: 'Anywhere' },
    1: { id: 1, title: 'Home' },
    2: { id: 2, title: 'Cafe' },
    3: { id: 3, title: 'Thoroughfare' },
    4: { id: 4, title: 'Clock' },
    5: { id: 5, title: 'Bridge' },
    6: { id: 6, title: 'Vantage' }
  },

  episodes: {
    4: {
      id: 4,
      title: 'Epilogue',
      chapterCount: 1,
      chapters: {
        1: {
          id: 1,
          location: 0,
          storyCount: 1,
          titles: {
            1: 'Hands'
          }
        }
      }
    },
    3: {
      id: 3,
      title: 'Transition',
      chapterCount: 5,
      chapters: {
        1: {
          id: 1,
          location: 2,
          storyCount: 1,
          titles: {
            1: 'Here'
          }
        },
        2: {
          id: 2,
          location: 6,
          storyCount: 1,
          titles: {
            1: 'Empty'
          }
        },
        3: {
          id: 3,
          location: 3,
          storyCount: 1,
          titles: {
            1: 'Wait'
          }
        },
        4: {
          id: 4,
          location: 4,
          storyCount: 1,
          titles: {
            1: 'Search'
          }
        },
        5: {
          id: 5,
          location: 1,
          storyCount: 1,
          titles: {
            1: 'Mothwings'
          }
        }
      }
    },
    2: {
      id: 2,
      title: 'Thread',
      chapterCount: 5,
      chapters: {
        1: {
          id: 1,
          location: 1,
          storyCount: 3,
          titles: {
            1: 'A New Place',
            2: 'The Architect',
            3: 'Ripple'
          }
        },
        2: {
          id: 2,
          location: 5,
          storyCount: 3,
          titles: {
            1: 'Boxes And Watches',
            2: 'Karst Landscapes',
            3: 'Look Again'
          }
        },
        3: {
          id: 3,
          location: 2,
          storyCount: 3,
          titles: {
            1: 'A Writer',
            2: 'An Attempt',
            3: 'This Is Not My City'
          }
        },
        4: {
          id: 4,
          location: 6,
          storyCount: 4,
          titles: {
            1: 'A Reflection',
            2: 'I Build A City',
            3: 'If This Was My City',
            4: 'An Orrery'
          }
        },
        5: {
          id: 5,
          location: 5,
          storyCount: 4,
          titles: {
            1: 'A Conversation',
            2: 'Acoustic Astronomy',
            3: 'I Can See The Tides Rise',
            4: 'I Stood By The Wharf'
          }
        }
      }
    },
    1: {
      id: 1,
      title: 'Assemble',
      chapterCount: 5,
      chapters: {
        1: {
          id: 1,
          location: 1,
          storyCount: 3,
          titles: {
            1: 'I stare out of the window',
            2: 'Rest',
            3: 'Dear Suzie'
          }
        },
        2: {
          id: 2,
          location: 2,
          storyCount: 4,
          titles: {
            1: 'Between',
            2: 'Burst',
            3: 'My Father',
            4: 'Tattoos'
          }
        },
        3: {
          id: 3,
          location: 3,
          storyCount: 3,
          titles: {
            1: 'Blink',
            2: 'Repeat',
            3: 'Carry Me'
          }
        },
        4: {
          id: 4,
          location: 4,
          storyCount: 4,
          titles: {
            1: 'A Reason',
            2: 'Ink',
            3: 'Marks',
            4: 'Reaching'
          }
        },
        5: {
          id: 5,
          location: 3,
          storyCount: 4,
          titles: {
            1: 'A Girl',
            2: 'An Answer',
            3: 'A Touch of Home',
            4: 'Waves'
          }
        }
      }
    }
  },

  initialProgress: {
    episode: 1,
    chapter: 1,
    number_of_stories: 0,
    welcome: true,
    finished: false,
    episode_interval: 60,
    email_notify: true,
    debug: false,
    fades: []
  }
}
export default conf
